import React from 'react'

import ToastService from 'services/toast.service'

import PhatButton from 'components/formElements/PhatButton'

import genericStyles from 'components/deckPage/modals/Export/generic.module.scss'

import { generateArenaText } from './helpers'
import { ExporterProps } from 'components/deckPage/modals/Export/types'

const Arena = ({ selectedCards, categoryMap }: ExporterProps) => {
  const fileContents = generateArenaText(selectedCards, categoryMap)

  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(fileContents)

      ToastService.create('Copied to clipboard', 'Deck Export', 'success')
    } catch {
      ToastService.create('Unable to copy to clipboard', 'Deck Export')
    }
  }

  return (
    <div>
      <p className={genericStyles.warning}>
        Note that Arena will only accept editions of cards that are available on Arena. If you receive an error when
        importing to Arena, please ensure all your cards are of an acceptable edition.
      </p>

      <div className={genericStyles.controls}>
        <PhatButton icon="copy outline" onClick={handleCopy} color="blue">
          Copy
        </PhatButton>
      </div>
    </div>
  )
}

export default Arena
